/** 契约枚举 → 设计稿中文标签；缺省回退原值，避免出现空白列。 */
export const CLS: Record<string, string> = { public: '公开', internal: '内部', restricted: '受限', confidential: '客户机密' }
export const REUSE: Record<string, string> = { direct: '直接', redact: '脱敏', reference_only: '参考', prohibited: '禁止' }
export const TASK_TONE: Record<string, string> = {
  succeeded: 'green', done: 'green', running: 'blue', queued: 'blue',
  retry_wait: 'orange', stale: 'orange', failed: 'red', dead_letter: 'red', cancelled: 'grey',
}

export function clsLabel(v: string): string { return CLS[v] ?? v }
export function reuseLabel(v: string): string { return REUSE[v] ?? v }
